import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  getDownloadPeriodicCensusReport,
  getPeriodicCensusReportInfo,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "./columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import data from "../../Mapper/MapAndTransform/sampleData";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    if (value === null) return <td></td>;
    return <td>$ {(Math.round(value * 100) / 100).toFixed(2)}</td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

const today = new Date();
const initialValues = {
  //companyName: "Select One",
  payDateTo: new Date(today.setDate(today.getDate())),
  payDateFrom: new Date(today.setDate(today.getDate() - 30)),
  companyId: null,
};

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Plan ID",
    className: "column-rkPlanNumber",
    columnName: "companyName",
    field: "rkPlanNumber",
    width: 173,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 2,
    label: "Plan Name",
    className: "column-planName",
    columnName: "planName",
    field: "planName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 3,
    label: "Plan Groups",
    className: "column-planGroups",
    columnName: "planGroups",
    field: "planGroups",
    width: 173,
    dataType: "alphaNumeric",
    field1: "planGroups",
  },
  {
    value: 4,
    label: "Employee ID",
    className: "column-employeeNo",
    columnName: "employeeNo",
    field: "employeeNo",
    width: 144,
    dataType: "alphaNumeric",
    field1: "employeeNo",
  },
  {
    value: 5,
    label: "First Name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 6,
    label: "Middle Initial",
    className: "column-middleInitial",
    columnName: "middleInitial",
    field: "middleInitial",
    width: 120,
    dataType: "alphaNumeric",
    field1: "middleInitial",
  },
  {
    value: 7,
    label: "Last Name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 8,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 250,
    dataType: "alphaNumeric",
    field1: "ssn",
  },

  {
    value: 9,
    label: "Gender",
    className: "column-gender",
    columnName: "gender",
    field: "gender",
    width: 250,
    dataType: "alphaNumeric",
    field1: "gender",
  },

  {
    value: 10,
    label: "Address 1",
    className: "column-Address",
    columnName: "address1",
    field: "address1",
    width: 250,
    dataType: "alphaNumeric",
    field1: "address1",
  },

  {
    value: 11,
    label: "Address 2",
    className: "column-Address",
    columnName: "address2",
    field: "address2",
    width: 250,
    dataType: "alphaNumeric",
    field1: "address2",
  },

  {
    value: 12,
    label: "City",
    className: "column-City",
    columnName: "city",
    field: "city",
    width: 250,
    dataType: "alphaNumeric",
    field1: "city",
  },

  {
    value: 13,
    label: "State",
    className: "column-State",
    columnName: "state",
    field: "state",
    width: 250,
    dataType: "alphaNumeric",
    field1: "state",
  },

  {
    value: 14,
    label: "Zip Code",
    className: "column-ZipCode",
    columnName: "zipCode",
    field: "zipCode",
    width: 250,
    dataType: "alphaNumeric",
    field1: "zipCode",
  },

  {
    value: 15,
    label: "Country",
    className: "column-country",
    columnName: "country",
    field: "country",
    width: 250,
    dataType: "alphaNumeric",
    field1: "country",
  },

  {
    value: 16,
    label: "Birth Date",
    className: "column-birthDate",
    columnName: "birthDate",
    field: "birthDate",
    width: 250,
    dataType: "date",
    field1: "birthDateFrom",
    field2: "birthDateTo",
  },
  {
    value: 17,
    label: "Hire Date",
    className: "column-hireDate",
    columnName: "hireDate",
    field: "hireDate",
    width: 250,
    dataType: "date",
    field1: "hireDateFrom",
    field2: "hireDateTo",
  },
  {
    value: 18,
    label: "Termination Date",
    className: "column-terminationDate",
    columnName: "terminationDate",
    field: "terminationDate",
    width: 250,
    dataType: "date",
    field1: "terminationDateFrom",
    field2: "terminationDateTo",
  },
  {
    value: 19,
    label: "Rehire Date",
    className: "column-rehireDate",
    columnName: "rehireDate",
    field: "rehireDate",
    width: 250,
    dataType: "date",
    field1: "rehireDateFrom",
    field2: "rehireDateTo",
  },
  {
    value: 20,
    label: "Division/Location",
    className: "column-divisionOrLocation",
    columnName: "divisionOrLocation",
    field: "divisionOrLocation",
    width: 250,
    dataType: "alphaNumeric",
    field1: "divisionOrLocation",
  },
  {
    value: 21,
    label: "Excluded Classification",
    className: "column-excludedClassification",
    columnName: "excludedClassification",
    field: "excludedClassification",
    width: 250,
    dataType: "alphaNumeric",
    field1: "excludedClassification",
  },
  {
    value: 22,
    label: "Employee Status",
    className: "column-employeeStatus",
    columnName: "employeeStatus",
    field: "employeeStatus",
    width: 250,
    dataType: "alphaNumeric",
    field1: "employeeStatus",
  },
  {
    value: 23,
    label: "Union Employee",
    className: "column-ssn",
    columnName: "unionEmployee",
    field: "unionEmployee",
    width: 250,
    dataType: "boolean",
    field1: "unionEmployee",
  },
  {
    value: 24,
    label: "Officer",
    className: "column-officer",
    columnName: "officer",
    field: "officer",
    width: 250,
    dataType: "boolean",
    field1: "officer",
  },
  {
    value: 25,
    label: "Hours",
    className: "column-hours",
    columnName: "hours",
    field: "hours",
    width: 250,
    dataType: "numeric",
    field1: "hoursFrom",
    field2: "hoursTo",
  },
  {
    value: 26,
    label: "Gross Compensation ",
    className: "column-grossCompensation",
    columnName: "grossCompensation",
    field: "grossCompensation",
    width: 250,
    dataType: "amount",
    field1: "grossCompensationFrom",
    field2: "grossCompensationTo",
  },
  {
    value: 27,
    label: "Post Entry Plan Compensation",
    className: "column-postEntryPlanCompensation",
    columnName: "postEntryPlanCompensation",
    field: "postEntryPlanCompensation",
    width: 300,
    dataType: "amount",
    field1: "postEntryPlanCompensationFrom",
    field2: "postEntryPlanCompensationTo",
  },
  {
    value: 28,
    label: "Plan Compensation",
    className: "column-planCompensation",
    columnName: "planCompensation",
    field: "planCompensation",
    width: 250,
    dataType: "amount",
    field1: "planCompensationFrom",
    field2: "planCompensationTo",
  },
  {
    value: 29,
    label: "Pretax",
    className: "column-pretax",
    columnName: "pretax",
    field: "pretax",
    width: 250,
    dataType: "amount",
    field1: "pretaxFrom",
    field2: "pretaxTo",
  },
  {
    value: 30,
    label: "After tax",
    className: "column-aftertax",
    columnName: "aftertax",
    field: "aftertax",
    width: 250,
    dataType: "amount",
    field1: "aftertaxFrom",
    field2: "aftertaxTo",
  },
  {
    value: 31,
    label: "Roth",
    className: "column-roth",
    columnName: "roth",
    field: "roth",
    width: 250,
    dataType: "amount",
    field1: "rothFrom",
    field2: "rothTo",
  },
  {
    value: 32,
    label: "Pretax Catch up",
    className: "column-pretaxCatchup",
    columnName: "pretaxCatchup",
    field: "pretaxCatchup",
    width: 250,
    dataType: "amount",
    field1: "pretaxCatchupFrom",
    field2: "pretaxCatchupTo",
  },
  {
    value: 33,
    label: "Roth Catch up",
    className: "column-rothCatchup",
    columnName: "rothCatchup",
    field: "rothCatchup",
    width: 250,
    dataType: "amount",
    field1: "rothCatchupFrom",
    field2: "rothCatchupTo",
  },
  {
    value: 34,
    label: "Employer Match",
    className: "column-employerMatch",
    columnName: "employerMatch",
    field: "employerMatch",
    width: 250,
    dataType: "amount",
    field1: "employerMatchFrom",
    field2: "employerMatchto",
  },
  {
    value: 35,
    label: "Employer Discretionary ",
    className: "column-employerDiscretionary",
    columnName: "employerDiscretionary",
    field: "employerDiscretionary",
    width: 250,
    dataType: "amount",
    field1: "employerDiscretionaryFrom",
    field2: "employerDiscretionaryTo",
  },
  {
    value: 36,
    label: "Employer Prevailing Wages",
    className: "column-employerPrevailingWages",
    columnName: "employerPrevailingWages",
    field: "employerPrevailingWages",
    width: 250,
    dataType: "amount",
    field1: "employerPrevailingWagesFrom",
    field2: "employerPrevailingWagesTo",
  },
  {
    value: 37,
    label: "Safe Harbor Match",
    className: "column-safeHarborMatch",
    columnName: "safeHarbourMatch",
    field: "safeHarbourMatch",
    width: 250,
    dataType: "amount",
    field1: "safeHarbourMatchFrom",
    field2: "safeHarbourMatchTo",
  },
  {
    value: 38,
    label: "Safe Harbor Non-Elective",
    className: "column-safeHarborNonElective",
    columnName: "safeHarbourNonElective",
    field: "safeHarbourNonElective",
    width: 250,
    dataType: "amount",
    field1: "safeHarbourNonElectiveFrom",
    field2: "safeHarbourNonElectiveTo",
  },
  {
    value: 39,
    label: "QMAC",
    className: "column-qmac",
    columnName: "qmac",
    field: "qmac",
    width: 250,
    dataType: "amount",
    field1: "qmacFrom",
    field2: "qmacTo",
  },
  {
    value: 40,
    label: "QNEC",
    className: "column-qnec",
    columnName: "qnec",
    field: "qnec",
    width: 250,
    dataType: "amount",
    field1: "qmacFrom",
    field2: "qmacTo",
  },
];

const PeriodicCensus = (props) => {
  const [final, setFinal] = useState(columns);
  const [gridFilters, setGridFilters] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
  ]);
  const [totalRecord, setTotalRecord] = useState(0);
  const formName = manageReportsFormNames.PERIODIC_CENSUS;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [trigger, setTrigger] = useState(true);

  const [isScroll, setIsScroll] = useState(false);
  const [sorting, setSorting] = useState();
  const [tableContent, setTableContent] = useState([]);

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const apiCall = (data) => {
    setDataLoading(true);
    getPeriodicCensusReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setTableContent(response.periodicCensusReportData);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });

    //setToggle(!toggle);
  };

  useDeepEffect(() => {
    if (!isEmpty(gridFilters)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
        from: 1,
        count: 20,
      });
      setPageCount(1);
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        payDateFrom: usDateFormat(values.payDateFrom),
        payDateTo: usDateFormat(values.payDateTo),
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setTableContent([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          payDateFrom: filteredValues.payDateFrom,
          payDateTo: filteredValues.payDateTo,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getPeriodicCensusReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.periodicCensusReportData.length === 0) {
              setIsScroll(false);
            } else {
              setTableContent([
                ...tableContent,
                ...response.periodicCensusReportData,
              ]);
            }
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns([final.map((item) => item.value)]);

    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownloadPeriodicCensusReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `PeriodicCensus_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div> </div>}</td>;
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };
  const booleanFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    let temp = "-";
    if (value === true) temp = "YES";
    else if (value === false) temp = "NO";
    return renderValue(temp);
  };

  return (
    <ManageReportLayout rptName="Periodic Census">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex ">
                    <div className="d-flex mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "130px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.sponsorOrganizationName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date from "
                          isRequired
                          name={fields.payDateFrom}
                          value={usDateFormat(values[fields.payDateFrom])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateFrom, "")}
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(
                              value
                            ) && isEmpty(values[fields.payDateFrom])
                              ? "Required"
                              : null
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateFrom, value)
                              }
                              value={usDateFormat(values[fields.payDateFrom])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date to"
                          isRequired
                          name={fields.payDateTo}
                          value={usDateFormat(values[fields.payDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateTo, "")}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateTo, value)
                              }
                              value={usDateFormat(values[fields.payDateTo])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.payDateFrom] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      className=" mt-12 sort-button mr-3"
                      variant="secondary"
                      style={{ marginTop: "30px" }}
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              fields.companyId,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.sponsorOrganizationId,
                              fields.amountFrom,
                              fields.amountTo,
                              fields.payDateFrom,
                              fields.payDateTo,
                            ],
                          }),
                        });
                        setFieldValue(
                          fields.payDateFrom,
                          initialValues.payDateFrom
                        );
                        setFieldValue(
                          fields.payDateTo,
                          initialValues.payDateTo
                        );
                        setFieldValue(fields.nameOrSsn, "");
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setTableContent([]);
                        setCompanyList("");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      className="mt-12 sort-button"
                      style={{
                        lineHeight: "19px",
                        marginLeft: "8px",
                        marginTop: "30px",
                      }}
                      variant="secondary"
                      type="submit"
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex flex-col">
            <div
              style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
            >
              {companyList ? `Showing result for ${companyList} company` : null}
            </div>
            <div className="ft-12 grey-text font-weight-500">
              {totalRecord} Records found
            </div>
          </div>
          <div className="d-flex pad-top-10">
            <div style={{ diplay: "flex", flexDirection: "column" }}>
              <div>
                <Button
                  variant="secondary"
                  className="column-header"
                  onClick={showManageColumns}
                >
                  <span className="marg-right-6">
                    <i class="fal fa-columns"></i>
                  </span>
                  Column
                </Button>
              </div>
              <div
                className="manage-column-dropdown"
                style={{ display: "none" }}
              >
                <div className="manage-columns ">
                  <p className="manage-columns-button"> Manage columns</p>
                  <p
                    className="apply-button"
                    onClick={() => {
                      hideColumns();
                      setTrigger(!trigger);
                    }}
                  >
                    Close
                  </p>
                </div>
                <div>
                  <MultiSelectDropdown
                    hideSelectedOptions="FALSE"
                    width="269px"
                    height="200px"
                    maxHeight="300px"
                    position="absolute"
                    background="white"
                    zIndex="2"
                    options={columns}
                    onSelect={(value) => {
                      setSelectedColumns(value);
                    }}
                    name={"Columns"}
                    value={selectedColumns}
                    trigger={trigger}
                    // disabled={}
                    // isTypeAhead={isEdit}
                  />
                </div>
                <div style={{ marginTop: "220px", paddingLeft: "100px" }}>
                  <Button onClick={applyColumns}>Apply</Button>
                </div>
              </div>
            </div>
            <div className="ft-12 grey-text font-weight-500 marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
                // onClick={<ExcelExport />}
                onClick={() => !isEmpty(tableContent) && exportReportFile()}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "boolean" && booleanFieldRender) ||
                        (column.dataType === "date" && dateForm) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <ColumnMenu
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default PeriodicCensus;
